import { Component, Prop } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';

import TemasRegistro from '@/entities/snp/solicitud/posgrado/temas/temas-registro.vue';
import TemasListado from '@/entities/snp/solicitud/posgrado/temas/temas-listado.vue';
import { RegistroTemaSnp } from '@/shared/model/snp/temas.model';

@Component({
  components: {
    temasRegistro: TemasRegistro,
    temasListado: TemasListado,
  },
})
export default class TemasComponent extends ApeironComponent {
  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  public esVisibleRegistro = false;
  public esVisibleListado = true;

  public temaEdicion: RegistroTemaSnp = new RegistroTemaSnp();
  public temaAgregar: RegistroTemaSnp = new RegistroTemaSnp();

  public editarTema(tema: RegistroTemaSnp): void {
    this.temaEdicion = { ...tema };
    this.esVisibleRegistro = true;
    this.esVisibleListado = false;
  }

  public agregarTemaATabla(tema: RegistroTemaSnp): void {
    this.esVisibleRegistro = false;
    this.esVisibleListado = true;
    this.temaAgregar = { ...tema };
  }

  get mostrarTexto() {
    return this.solicitud?.temas?.length === 0 || !this.solicitud?.temas;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
